<template>
    <div>

        <!-- Default layout -->
        <a-layout class="layout-dashboard" id="layout-dashboard"
                  :class="[navbarFixed ? 'navbar-fixed' : '', !sidebarCollapsed ? 'has-sidebar' : '', layoutClass, sidebarMinimized ? 'sidebar-minimized' : '' ]"
        >

            <!-- Main Sidebar -->
            <default-sidebar :sidebarCollapsed="sidebarCollapsed"
                             :sidebarColor="sidebarColor"
                             :sidebarTheme="sidebarTheme"
                             @toggleSidebar="toggleSidebar"
                             @minimizeSidebar="minimizeSidebar"
            >
            </default-sidebar> 
            <!-- / Main Sidebar -->

            <!-- Layout Content -->
            <a-layout>
                <!-- Header -->
                <default-header :navbarFixed="navbarFixed"
                                :sidebarCollapsed="sidebarCollapsed"
                                @toggleSidebar="toggleSidebar"

                >
                </default-header>
                <!-- / Header -->

                <!-- Page Content -->
                <a-layout-content>
                    <router-view :navbarFixed="navbarFixed"/>
                </a-layout-content>
                <!-- / Page Content -->

                <!-- Footer -->
                <default-footer></default-footer>
                <!-- / Footer -->

            </a-layout>
            <!-- /Layout Content -->
                   

        </a-layout>

    </div>
</template>

<script>
import DefaultHeader from './components/DefaultHeader.vue'
import DefaultFooter from './components/DefaultFooter.vue'
import DefaultSidebar from './components/DefaultSidebar.vue'
export default {
    components : {
        DefaultHeader,
        DefaultFooter,
        DefaultSidebar
    },
    computed: {
        layoutClass() {
            return this.$route.meta.layoutClass;
        }
    },
    data () {
        return {
            // Sidebar collapsed status.
			sidebarCollapsed: false,

			// Sidebar minimized status.
			sidebarMinimized: false,
				
			// Main sidebar color.
			sidebarColor: "primary",
				
			// Main sidebar theme : light, white, dark.
			sidebarTheme: "light",

			// Header fixed status.
			navbarFixed: false,

			// Settings drawer visiblility status.
			showSettingsDrawer: false,
        }
    },

    methods : {
        // Toggle sidebar's collapsed status.
		toggleSidebar( value ) {
		    this.sidebarCollapsed = value ;
            console.log('toogle sidebar:' + value  )
		},
			
		// Toggle sidebar's minimized status.
		minimizeSidebar( value ) {
			this.sidebarMinimized = ! this.sidebarMinimized ;
		},
			
		// Toggle ettings drawer's visiblility status.
		toggleSettingsDrawer( value ) {
			this.showSettingsDrawer = value ;
		},
			
		// Toggle navbar's fixed status.
		toggleNavbarPosition( value ) {
			this.navbarFixed = value ;
		},
			
		// Change sidebar's theme.
		updateSidebarTheme( value ) {
			this.sidebarTheme = value ;
		},
			
		// Change sidebar's color.
		updateSidebarColor( value ) {
			this.sidebarColor = value ;
		},
    }

  
}
</script>